((globalCore) => {

  /**
  * Класс реквизита выбор записи справочника.
  * @namespace Core.requisites
  * since 5.8.3.9000
  */
  var ReferenceSelect = ReferenceSelectBase.extend({
    /**
    * Конструктор.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceSelect.init
    */
    init: function (inp, options, img) {
      var self = this;
      this._super(inp, options, img);
    },

    /**
    * Функция обработки нажатия на иконку.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceSelect.onImgClick
    * @param {object} ev Событие клика.
    */
    onImgClick: function (ev) {
      var self = this;
      ev.preventDefault();
      ev.stopPropagation();
      if (!self.inp.attr('readonly') && !self.inp.attr('disabled')) {
        self.container.hide();
        self.table.empty().removeData('refcode');
        self.currentPage = 1;
        self.clearBlurTimeout();
        self.suggestLastMode = 'show_all';
        self.suggest(function () {
          self.results.scrollTop(0);
        });
      }
    },

    /**
    * Функция удаления таймаута на событии onblur главного inputa.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceSelect.clearBlurTimeout
    */
    clearBlurTimeout: function () {
      var self = this;
      clearTimeout(self.close);
      self.inp.focus();
    },

    /**
    * Функция обработки нажатий на клавиши.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceSelect.process
    * @param {object} e Событие клика.
    */
    process: function (e) {
      ReferenceSelectBase.prototype.process.call(this, e);
      var self = e.data;

      //alt+down для раскрытия полного списка.
      if (e.altKey && e.keyCode == 40 && $.trim(self.inp.val()) == '' && !self.container.is(':visible')) {
        self.onImgClick(e);
      }

      // Скрытие/раскрытие записей справочника.
      if (self.refcodesCount > 1 && /^37$|^39$/.test(e.keyCode) && self.container.is(':visible')) {
        e.preventDefault();
        e.stopPropagation();
        //left, right
        if (e.keyCode == 37 || e.keyCode == 39) {
          self.selectReference(self.moveReference(0));
        }
      }

      // Backspace работает всегда
      if (/^8$/.test(e.keyCode) && self.inp.val() == '') {
        e.preventDefault();
        e.stopPropagation();
        self.deleteItems(self.inp.prev());
      }
    },

    /**
    * Функция устанавливает значение реквизита.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceSelect.setValue
    * @param {Array} newValues новое значение.
    * @param {boolean} needTriggerResult признак необходимости вызова события установки значения.
    */
    setValue: function (newValue, needTriggerResult) {
      var self = this;
      var oldHiddVal = self.hidd.val();

      try {
        self.deleteAllItems(false);
      } catch (e) {
        console.log(e);
      }

      if (newValue != null) {
        // Создаем новый выбранный элемент.
        self.createNewSelecetedItem(newValue);
      }

      if (!!needTriggerResult) {
        if (self.allowlike) {
          self.triggerResultEvent(oldHiddVal, newValue);
        } else {
          self.inp.trigger('changeOnSelectValue', [newValue]);
        }
      }

      self.inp.data('selected', '' + (newValue != null));
    },

    /**
    * Функция вызова события установки значения в реквизите множественного выбора.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceSelect.triggerResultEvent
    * @param {string} oldHiddVal старое значение.
    * @param {string} val новое значения.
    */
    triggerResultEvent: function (oldHiddVal, val) {
      var self = this;
      if (self.hidd.val() != oldHiddVal) {
        self.inp.trigger("result", [val]);
      }
    },

    /**
    * Функция получает результат запроса.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceSelect.getQueryValue
    */
    getQueryValue: function () {
      var self = this;
      var v = self.inp.val();
      return $.trim(v);
    },

    /**
    * Функция преобразования сообщения.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceSelect.formatMessage
    * @param {string} msg Сообщение.
    * @returns {string} Преобразованное сообщение.
    */
    formatMessage: function (msg) {
      return msg.replace('^', '. ');
    },

    /**
   * Функция вызова события.
   * since 5.8.3.9000
   * @method Core.requisites.ReferenceSelect.callResult
   */
    callResult() {
      this.inp.trigger('result', [null]);
    },
  });

  globalCore.ReferenceSelect = ReferenceSelect;
})(window.Core.requisites);
